import { render, staticRenderFns } from "./data15.vue?vue&type=template&id=e0cc0b66&scoped=true"
import script from "./data15.vue?vue&type=script&lang=js"
export * from "./data15.vue?vue&type=script&lang=js"
import style1 from "./data15.vue?vue&type=style&index=1&id=e0cc0b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cc0b66",
  null
  
)

export default component.exports